<nz-comment id="note-input">
    @if (!readonly()) {
        <nz-comment-content>
            <pf-input
                inputType="textarea"
                [control]="noteInputControl"></pf-input>
            <div id="note-input-buttons">
                <pf-button buttonType="action" (click)="open()"
                    >Attach File
                </pf-button>
                <pf-button
                    buttonType="submit"
                    [disabled]="noteInputControl.invalid"
                    (click)="addNote()"
                    >Add Note
                </pf-button>
            </div>
        </nz-comment-content>
    }
</nz-comment>
<nz-list
    [nzDataSource]="thread()"
    [nzRenderItem]="item"
    nzItemLayout="horizontal"
    nzSize="small">
    <ng-template #item let-item>
        <nz-comment [nzAuthor]="item.user" [nzDatetime]="item.date">
            <nz-comment-content>
                <div class="note-content">
                    @if (item.documentUrl$) {
                        <div class="note-document">
                            <a
                                #documentLink
                                [href]="item.documentUrl$ | async"
                                target="_blank">
                                @if (item.documentIsImage) {
                                    <img [src]="item.documentUrl$ | async" />
                                } @else {
                                    <pf-button
                                        buttonType="download"
                                        (click)="documentLink.click()"
                                        >View/Download
                                    </pf-button>
                                }
                            </a>
                        </div>
                    }
                    <p>{{ item.text }}</p>
                </div>
            </nz-comment-content>
        </nz-comment>
    </ng-template>
</nz-list>

<pf-document-form
    #form
    [document]="selectedDocument()"
    [saving]="uploadingDocument()"
    (pfSubmit)="onDocumentUploadSubmit($event)"></pf-document-form>
